import axios from 'axios';
import {API} from "@/services/url";

export default {
	getAllCompanyGroups : function (success, error) {
		axios.get(API.companyGroup.all)
			.then(r => success(r.data.companyGroupList))
			.catch(e => error(e.response.data.message));

	},
	createCompanyGroup : function (data, success, error){
		axios.post(API.companyGroup.create, data)
			.then(r => success(r.data.companyGroupList))
			.catch(e => error(e.response.data.message));
	},
	updateCompanyGroup : function (companyGroupId, data, success, error){
		axios.post(API.companyGroup.update + companyGroupId, data)
			.then(r => success(r.data.companyGroupList))
			.catch(e => error(e.response.data.message));
	}
}
